import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import BackIcon from "@material-ui/icons/ChevronLeft";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";

class Appbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };

  }

  componentDidMount() {

  }

  historyBack(){
    window.history.back();
  }

  render() {
    const classes = {
      root: {
        flexGrow: 1
      },
      grow: {
        flexGrow: 1
      },
      menuButton: {
        marginLeft: -12,
        marginRight: 20
      }
    };

    return (

      <div style={classes.root} >
        <AppBar position="fixed" className="padding-ios">
          <Toolbar >
            {this.props.menu.showBackButton
              ?
              <IconButton
                style={classes.menuButton}
                color="inherit"
                aria-label="Menu"
                onClick={this.historyBack}
              >
                <BackIcon />
              </IconButton>
              :
              <IconButton
                style={classes.menuButton}
                color="inherit"
                aria-label="Menu"
                onClick={this.props.onMenuClick}
              >
                <MenuIcon />
              </IconButton> 
            }

            {this.props.menu.title}
            <div style={classes.grow} />
            {this.props.handleActions}
            {this.props.handleNewFunction && (
              <Fab
                color="primary"
                aria-label="Add"
                className={classes.fab}
                onClick={() => this.props.handleNewFunction()}
              >
                <AddIcon />
              </Fab>
            )}
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}
export default Appbar;
